import { sleep } from "@shared/utils/tools.ts";

import json from "../../json/owners.json";

export default async () => {
  await sleep(350);
  return JSON.parse(JSON.stringify(await json));
};
